export const ItemTypes = {
  SUBDIVISION: 'subdivision',
  STUFF: 'stuff',
};
